import './collab.css';

import {
  format,
  h,
} from 'typewriter-editor';

import {
  getAuthorColor,
  getUser,
} from './collab-stores';

export const author = format({
  name: 'author',
  selector: 'format-author',
  render: (attributes, children) => {
    if (attributes.author === true) {
      return null;
    }
    return h(
      'format-author',
      {
        'data-uid': `${attributes.author}`,
        'data-name': getUser.get()(attributes.author).name,
        class: getAuthorColor(attributes.author),
      },
      children
    );
  },
});
